export default __webpack_public_path__ + "b5a06af475cfb12be0fd69ae729b30ac.png";